/* eslint-disable import/prefer-default-export */

import { useState } from 'react'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { getLabel } from 'utils/widgetTypeUtil'

import { PopularMediaWidgetsType, SelectedMedia } from './types'

export const useMediaModalInfo = (widgetId: number) => {
  const widgetSetting = useDashboardWidgetSetting<PopularMediaWidgetsType>(widgetId)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedMedia, setSelectedMedia] = useState<SelectedMedia>({
    mediaModalDetail: {},
    mediaModalMedias: []
  })
  const handleMediaClick = (targetMedia: SelectedMedia) => {
    setSelectedMedia(targetMedia)
    setIsModalOpen(true)
  }

  return {
    title: widgetSetting?.name || getLabel(widgetSetting?.type),
    isModalOpen,
    setIsModalOpen,
    selectedMedia,
    handleMediaClick
  }
}
